<template>
    <div class="container-fluid">
        <admin-header :name="$t('Profile')"/>
        <app-card>
            <div class="row">
                <div class="col-4">
                    <validation-observer v-slot="{ validate }" slim>
                        <form @submit.prevent="update(validate)">
                            <app-input id="name" v-model="form.name" name="name" rules="required">
                                <template #label>
                                    {{ $t('Name') }}*
                                </template>
                            </app-input>

                            <app-input id="email" v-model="form.email" name="email" rules="required|email" type="email">
                                <template #label>
                                    {{ $t('Email') }}*
                                </template>
                            </app-input>

                            <app-input id="password" v-model="form.password" name="password" rules="required|password:@password_confirmation" type="password">
                                <template #label>
                                    {{ $t('Password') }}*
                                </template>
                            </app-input>

                            <app-input id="password_confirmation" v-model="form.password_confirmation" rules="required" name="password_confirmation" type="password">
                                <template #label>
                                    {{ $t('Confirm password') }}*
                                </template>
                            </app-input>

                            <app-button :loading="loading" small>
                                {{ $t('Update') }}
                            </app-button>
                        </form>
                    </validation-observer>
                </div>
            </div>
        </app-card>
    </div>
</template>

<script>
import UserService from '@services/user.service';

export default {
    data() {
        return {
            form: {},
            loading: false
        };
    },
    methods: {
        getUser() {
            UserService.profile().then(res => {
                this.form = res;
            });
        },
        update(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    UserService.profileUpdate(this.form).then(res => {
                        this.form.name = res.name;
                        this.form.email = res.email;
                        this.$toastr.s(this.$t('Updated'));
                        this.loading = false;
                    });
                }
            });
        }
    },
    created() {
        this.getUser();
    },
    metaInfo() {
        return {
            title: this.$t('My profile')
        };
    }
};
</script>
